import React from "react";
import {
  BalanceUlSingle,
  BalanceLiSingle,
  FirstName,
  BalanceAmount,
  BalanceLabel,
} from "./BalanceStyles";
import { formatNumber } from "../../../../lib/utils";
import ProfileIcon from "../../../svgs/ProfileIcon";

const ProfileBalanceSingle = (props) => {
  const { visitInfo, isMobile, delimeter = ",", balanceLabel } = props;

  return (
    <BalanceUlSingle className="fs-mask" isMobile={isMobile}>
      <BalanceLiSingle isMobile={isMobile}>
        <ProfileIcon />
        <FirstName isMobile={isMobile}>{visitInfo.firstName}</FirstName>
      </BalanceLiSingle>
      <BalanceLiSingle isMobile={isMobile}>
        <BalanceAmount isMobile={isMobile}>
          {formatNumber(visitInfo.balance, delimeter)}
        </BalanceAmount>
        <BalanceLabel isMobile={isMobile}>{balanceLabel}</BalanceLabel>
      </BalanceLiSingle>
    </BalanceUlSingle>
  );
};

const ProfileOneBalance = (props) => {
  const {
    thousandsSeparator = ',',
    balanceLabel = 'Miles',
  } = props?.globalPageConfig || {};

  return (
    <ProfileBalanceSingle
      {...props}
      delimeter={thousandsSeparator}
      balanceLabel={balanceLabel}
    />
  );
};
export default ProfileOneBalance;
